﻿/*
Copyright MITSUBISHI Elec.
*/

/** デフォルト条件パネルセレクタ */
BlenderConditionPanel.DEFAULT_COND_PANEL_SELECTOR  = ".condPanel";

/** デフォルトボタンID */
BlenderConditionPanel.DEFAULT_BTN_ID  = "showBtn";

/** デフォルトModifyChecker変数名 */
BlenderConditionPanel.DEFAULT_MODIFY_CHECKER_ID = "modifyChecker";

/** カレンダー形式：年月日  */
BlenderConditionPanel.DT_CLASS = "bl-date-ymd";
/** カレンダー形式：年月日時分  */
BlenderConditionPanel.DT_CLASS_SHOWTIME = "bl-date-ymdhm";

/** カレンダーアイコン画像 */
BlenderConditionPanel.ICON_CALENDAR = "calendar.gif";

/** 条件フィールドカスタムデータ属性のパターン */
BlenderConditionPanel.COND_ATTR_DATA_CUSTOM  = /^data\-(?!bl\-)/;
/** 条件フィールドカスタムデータ属性：必須項目 */
BlenderConditionPanel.COND_ATTR_BL_REQUIRED  = "data-bl-required";
/** 条件フィールドカスタムデータ属性：範囲入力 */
BlenderConditionPanel.COND_ATTR_BL_RANGE  = "data-bl-range";
/** 条件フィールドカスタムデータ属性：接尾辞 */
BlenderConditionPanel.COND_ATTR_BL_SUFFIX  = "data-bl-suffix";

/** 条件フィールドカスタムデータ属性：時刻表示（BLEnDer Calendar機能利用） */
BlenderConditionPanel.COND_ATTR_BL_SHOWTIME  = "data-bl-showtime";
/** 条件フィールドカスタムデータ属性：時刻表示（BLEnDer TimeInput機能利用） */
BlenderConditionPanel.COND_ATTR_BL_SHOWTIME2  = "data-bl-showtime2";
/** 条件フィールドカスタムデータ属性：時刻の変化量(分) */
BlenderConditionPanel.COND_ATTR_BL_TIMESTEP  = "data-bl-timestep";

/** 条件フィールドカスタムデータ属性：スピナーボタン選択 */
BlenderConditionPanel.COND_ATTR_BL_TIMESPINNER  = "data-bl-timespinner";
/** 条件フィールドカスタムデータ属性：クリアボタン非表示 */
BlenderConditionPanel.COND_ATTR_BL_DISABLEDCLEARBTN  = "data-bl-disabledClearBtn";

/**
 * getRequestValue で戻されるデータの構造を旧バージョンのものにする。
 * (fldSetの値が配列になる)
 */
BlenderConditionPanel.REQUEST_VALUE_TYPE_LEGACY = false;

/**
 * ## BlenderConditionPanel
 * 条件パネル用コンポーネント。
 * idに引数で指定した文字列を持つタグがあった場合、そのタグを使って条件パネルを作成する。
 * タグが存在しない場合はデフォルト条件パネルセレクタを使い取得したタグを使って作成する。
 *
 * @class BlenderConditionPanel
 * @module BlenderConditionPanel
 * @constractor
 * @param id {string}
 */
function BlenderConditionPanel(id) {
	"use strict";
	this.tagId = id;
	this.targetObj = $("#" + id);
	this.multiMode = true;

	if (this.targetObj.length == 0) {
		this.targetObj = $(BlenderConditionPanel.DEFAULT_COND_PANEL_SELECTOR);
		this.multiMode = false;
	}

	this.hideBtn = false;
	this.btnId = BlenderConditionPanel.DEFAULT_BTN_ID;
	this.modifyCheckerId = BlenderConditionPanel.DEFAULT_MODIFY_CHECKER_ID;

	this.data = [];

	// オブジェクトマネージャに登録
	BlenderObjectManager.putObject(id, this, "condPanel");

	BlenderComponent.call(this, id, "blender");
};

//Extends
BlenderConditionPanel.inherit(BlenderComponent);

/**
 * 条件パネル用コンポーネントのイメージパスを設定する。
 *
 * @method setImagePath
 * @param path {String} イメージパス
 */
BlenderConditionPanel.setImagePath = function(path) {
	BlenderConditionPanel.imagePath = path;
}

BlenderConditionPanel.setImagePath("../webjars/codebase/blender/imgs/");

/**
 * コンポーネントを初期化する。
 *
 * @method init
 * @param params {Object} パラメータ連想配列
 */
BlenderConditionPanel.prototype.init = function(params) {
	"use strict";
	params = params || {};

	this.i18n = BlenderCustomSettings.conditionPanelLangData;
	this.lang = params["lang"] || Object.keys(this.i18n)[0];
	this.targetObj.addClass(BlenderConditionPanel.DEFAULT_COND_PANEL_SELECTOR.substr(1) + "_" + this.skin);

	var msgData = $.extend({}, this.i18n[this.lang], params);
	var btnId = (this.multiMode ? this.btnId : BlenderConditionPanel.DEFAULT_BTN_ID);
	var modifyCheckerId = (this.multiMode ? this.modifyCheckerId : BlenderConditionPanel.DEFAULT_MODIFY_CHECKER_ID);
	var modifyChecker = window[modifyCheckerId] || (window[modifyCheckerId] = new BlenderModifyChecker());
	var generatorMap = BlenderConditionPanel._genarators;

	var tableRows = this.data.map(function(datum) {
		var spans = [];
		for (var i = 0, ilen = datum.length; i < ilen; i++) {
			var entry = datum[i];
			var type = entry.type || "none";

			var $span = $("<span class='cond-param'/>");
			spans.push($span);

			$span.append(this._createEntryLabel(type, entry, msgData));

			var genarator = generatorMap[type];
			if (genarator) {
				$span.append(genarator.createField(this, modifyChecker, entry, msgData));
			}

			if (+entry.matchMode) {
				$span.append(this._createMatchMode(entry, modifyChecker, msgData));
			}
		}
		return $("<tr/>").append($("<td/>").append(spans));
	}, this);

	if (tableRows[0]) {
		tableRows[0].append(this._createShowBtn(btnId, tableRows.length, msgData));
	}

	$("<table/>")
			.addClass("cond-panel-table-obj")
			.append($("<tbody/>").append(tableRows))
			.appendTo(this.targetObj);

	this.data.forEach(function(datum) {
		for (var i = 0, ilen = datum.length; i < ilen; i++) {
			var entry = datum[i];
			var type = entry.type || "none";
			var generator = generatorMap[type];

			if (generator && generator.beforeSetup(this, entry)) {
				generator.setup(this, modifyChecker, entry, msgData);
			}
		}
	}, this);
};

/**
 * 検索条件エントリのラベルを生成する。
 *
 * @method _createEntryLabel
 * @private
 * @param type {string} 条件タイプ
 * @param entry {Object} 条件パネル設定のオブジェクト
 * @param msgData {Object} メッセージデータ
 * @return {htmlString} エントリラベルを表す文字列
 */
BlenderConditionPanel.prototype._createEntryLabel = function(type, entry, msgData) {
	"use strict";
	var entryLabel = "<span class='cond-param-name'>"+ entry.label + "</span>";
	var CondPane = BlenderConditionPanel;

	if (CondPane.containsAttr(entry, CondPane.COND_ATTR_BL_REQUIRED)) {
		entryLabel += "<span class='cond-param-required'>" + msgData.symbolRequired +"</span>";
	}
	if (type !== "none") {
		entryLabel += "<span class='cond-param-separator'>" + msgData.symbolSeparator +"</span>";
	}
	entryLabel = "<span class='cond-param-label'>" + entryLabel + "</span>";

	return entryLabel;
};

/**
 * 条件種別選択を生成する。
 *
 * @method _createMatchMode
 * @private
 * @param entry {Object} 条件パネル設定のオブジェクト
 * @param modifyChecker {BlenderModifyChecker} 条件変更監視
 * @param msgData {Object} メッセージデータ
 * @return {JQuery} 条件種別選択を格納したJQueryインスタンス
 */
BlenderConditionPanel.prototype._createMatchMode = function(entry, modifyChecker, msgData) {
	"use strict";
	var self = this;
	var $ret = $("<select/>")
			.addClass("cond-panel-match-div")
			.attr("name", entry.name + "MatchDiv")
			.append([
				"<option value='1'>" + msgData.option1Label + "</option>",
				"<option value='2'>" + msgData.option2Label + "</option>"
			])
			.change(function(e){
				self._change(e.target.name);
			});

	modifyChecker.addTarget($ret);

	return $ret;
};

/**
 * 表示ボタンを生成する。
 *
 * @method _createShowBtn
 * @private
 * @param btnId {string} ボタンID
 * @param rowSpan {number} 行結合数
 * @param msgData {Object} メッセージデータ
 * @return {htmlString} 表示ボタンを表す文字列
 */
BlenderConditionPanel.prototype._createShowBtn = function(btnId, rowSpan, msgData) {
	var ret = "<td rowspan='" + rowSpan + "' style='vertical-align:top;'>";
	ret += "<input type='button' id='" + btnId + "' value='" + msgData.showBtnLabel
	ret += "' class='blender-button' style='float:right;";
	if (this.hideBtn) {
		ret += "display:none;";
	}
	ret += "' actionType='general'/></td>";
	return ret;
};

/**
 * 表示ボタンのIDを指定する。
 * 本設定はコンストラクタで指定したIDが有効な場合のみ機能する。
 * IDが無効の場合 BlenderConditionPanel.DEFAULT_BTN_ID をIDとする。
 *
 * @method setBtnId
 * @param btnId {string} ボタンID
 */
BlenderConditionPanel.prototype.setBtnId = function(btnId){
	this.btnId = btnId;
};

/**
 * ModifyCheckerのID(変数名)を指定する。
 * 本設定はコンストラクタで指定したIDが有効な場合のみ機能する。
 * IDが無効の場合 BlenderConditionPanel.DEFAULT_MODIFY_CHECKER_ID をID(変数)とする。
 *
 * @method setModifyCheckerId
 * @param modifyCheckerId {string} 変更監視のID
 */
BlenderConditionPanel.prototype.setModifyCheckerId = function(modifyCheckerId){
	this.modifyCheckerId = modifyCheckerId;
};

/**
 * 検索ボタンを表示する。
 *
 * @method showButton
 */
BlenderConditionPanel.prototype.showButton = function() {
	$("#" + this.btnId).css("display", "inline");
	this.hideBtn = false;
};

/**
 * 検索ボタンを非表示にする。
 *
 * @method hideButton
 */
BlenderConditionPanel.prototype.hideButton = function() {
	$("#" + this.btnId).css("display", "none");
	this.hideBtn = true;
};

/**
 * JSON形式のデータを設定する。
 *
 * @method setData
 * @param data {Object} JSON形式のデータ
 * @example
 * ex) [
 *　　　[
 *　　　　{"label":"機器区分", "name":"commType", "type":"select", "style":"width:130px", "items":[["","すべて"],["1","920MHz BLEnDer"],["2","1:N"],["3","PLC"]]},
 *　　　　{"label":"通信ID", "name":"commId", "type":"text", "style":"width:97px"},
 *　　　　{"label":"計器ID", "name":"meterId", "type":"text", "style":"width:97px"}
 *　　　],
 *　　　[
 *　　　　{"label":"主NAPID", "name":"priNapId", "type":"text", "style":"width:97px"}
 *　　　]
 *　　]
 */
BlenderConditionPanel.prototype.setData = function(data){
	this.data = data;
};

/**
 * リクエストデータ(json形式)を取得する。
 * ※placeholder や free を用いてユーザ側でコンポーネントを生成したものは値を取得できないため、別途取得すること。
 *
 * リクエストパラメータの名前は name 属性で指定したものが採用される。
 * matchMode を指定した際の追加パラメータの名前は name 属性に "-match" を追加したものが採用される。
 *
 * @method getRequestValue
 * @param savedValFlag {boolean} modifyCheckerに保存した値を取得するならばtrue、現在の入力値を取得するならばfalse（既定値）
 * @return {object} jsonデータ { "name値": "入力値", ... }
 */
BlenderConditionPanel.prototype.getRequestValue = function(savedValFlag) {
	"use strict";

	var data = this.data,
		$targetObj = this.targetObj,
		getterName = savedValFlag ? "savedVal" : "val",
		ret = {};

	for (var i = data.length - 1; i >= 0; i--) {
		var dataRow = data[i];

		for (var j = dataRow.length - 1; j >= 0; j--) {
			var entry = dataRow[j];
			var name = entry.name;

			switch (entry.type) {
			case "select":
				ret[name] = $("select[name='" + name + "']", $targetObj)[getterName]();
				break;
			case "timespan":
				[name + "S", name + "E"].forEach(function(nm) {
					var timeInput = window[nm];
					var val;

					if (timeInput && timeInput[getterName]) {
						val = timeInput[getterName]();
					}
					if (!val) {
						val = $('input[name="' + nm + '"]', $targetObj)[getterName]();
					}
					ret[nm] = val;
				});
				break;
			case "calendar":
			case "calendarspan":
			case "mcalendar":
			case "mcalendarBY":
				[name, (name + "S"), (name + "E")].forEach(function(nm) {
					var cal = window[nm];

					if (!cal || !cal[getterName]) {
						return; // BLEnDerCalendarインスタンスが無い場合は無視
					}
					var date = cal[getterName]();

					if (date) {
						var timeId = nm + "Time";
						var time = window[timeId] && window[timeId][getterName]();

						if (time) {
							date += (" " + time)
						}
					}
					ret[nm] = date;
				});
				break;
			case "fldSet":
				var vals = window[name][getterName]();
				ret[name] = BlenderConditionPanel.REQUEST_VALUE_TYPE_LEGACY ? vals : vals[0];
				break;
			case "text":
				ret[name] = $("input[name='" + name + "']", $targetObj)[getterName]();
				break;
			case "checkbox":
				var tmp = $("input[name='" + name + "']:checked", $targetObj)[getterName]();
				ret[name] = (tmp ? "1" : "0");
				break;
			default:
				break; // 処理なし
			}

			if (entry.matchMode !== undefined && entry.matchMode != 0) {
				ret[name + "-match"] = $("select[name='" + name + "MatchDiv" + "']", $targetObj)[getterName]();
			}
		}
	}
	return ret;
};

/**
 * 必須項目が入力されていて、リクエストが可能な状態であるかを判定する
 *
 * @method canRequest
 * @param savedValFlag {boolean} modifyCheckerに保存した値を取得するならばtrue、現在の入力値を取得するならばfalse（既定値）
 * @return {boolean} リクエストが可能ならば true、そうでないならばfalse
 */
BlenderConditionPanel.prototype.canRequest = function(savedValFlag) {
	"use strict";

	var ret = true;
	var requestValue = this.getRequestValue(savedValFlag);
	var data = this.data;
	var CP = BlenderConditionPanel;

	for (var i = data.length - 1; (i >= 0 && ret); i--) {
		var dataRow = data[i];

		for (var j = dataRow.length - 1; (j >= 0 && ret); j--) {
			var entry = dataRow[j];

			if (!CP.containsAttr(entry, CP.COND_ATTR_BL_REQUIRED)) {
				continue; // 必須項目ではないならば無視
			}

			var name = entry.name;
			var type = entry.type;

			if (type === "timespan" || type === "calendarspan" ||
					(type === "calendar" && CP.containsAttr(entry, CP.COND_ATTR_BL_RANGE))) {
				var valStart = requestValue[name + "S"];
				var valEnd = requestValue[name + "E"];

				if (!valStart || !valEnd) {
					ret = false;
				}
			} else if (type === "checkbox") {
				if (requestValue[name] !== "1") {
					ret = false;
				}
			} else {
				var val = requestValue[name];

				if (!val) {
					ret = false;
				}
			}
		}
	}
	return ret;
};

/**
 * フィールドを設定する。
 *
 * @method _setupField
 * @param obj {JQuery} フィールドの要素をラップしたJQueryインスタンス
 * @param entry {Object} 条件パネル設定オブジェクト
 * @param nameOption {string} 名前オプション
 * @private
 */
BlenderConditionPanel.prototype._setupField = function(obj, entry, nameOption) {
	"use strict";

	obj.attr("name", (null == nameOption ? entry.name : entry.name + nameOption));

	if (entry.cssClass != undefined) {
		obj.addClass(entry.cssClass);
	}
	if (entry.style != undefined ) {
		obj.attr("style", entry.style);
	}

	if (entry.attr) {
		var attributes = entry.attr.split(";");
		if (attributes) {
			for (var attr in attributes) {
				var attrArray = attributes[attr].split(":");
				var attrKey = attrArray[0].trim();
				var attrVal = attrArray[1];

				if (attrKey === BlenderConditionPanel.COND_ATTR_BL_REQUIRED) {
					obj.attr(attrKey, attrVal || "required");
				} else if (attrKey === "readonly" || attrKey === "disabled") {
					obj.attr(attrKey, true);
				} else if (attrKey === "maxlength") {
					obj.attr(attrKey, attrVal);
				} else if (attrKey.match(BlenderConditionPanel.COND_ATTR_DATA_CUSTOM)) {
					obj.attr(attrKey, attrVal || "true");
				}
			}
		}
	}
};

/**
 * 検索条件の変更を通知する。
 *
 * @private
 * @method _change
 * @param name {string} フィールド名
 */
BlenderConditionPanel.prototype._change = function( name ) {
	this._notifyEvent({
		type: "conditionChanged",
		srcName: name
	});
};

/**
 * 指定した属性が含まれているかを判定する。
 *
 * @method containsAttr
 * @static
 * @param entry {Object} 条件パネル設定のオブジェクト
 * @param attr {string} 対象の属性
 * @return {boolean} 指定した属性が含まれるならばtrue、それ以外は false
 */
BlenderConditionPanel.containsAttr = function(entry, attr) {
	"use strict";

	if (!entry.attr || !attr) {
		return false;
	}
	// 部分一致による誤判定回避のためセミコロンで囲む
	return (";" + entry.attr + ";").search(";\\s*" + attr + "\\s*[:;]") !== -1;
};

/**
 * 指定した属性値を取得する。
 *
 * @method getAttrVal
 * @static
 * @param entry {Object} 条件パネル設定のオブジェクト
 * @param attr {string} 対象の属性
 * @return {boolean} 指定した属性の値、存在しないならばnull
 */
BlenderConditionPanel.getAttrVal = function(entry, attr) {
	"use strict";

	if (!entry.attr || !attr) {
		return null;
	}
	// 部分一致による誤判定回避のためセミコロンで囲む
	var match = (";" + entry.attr + ";").match(";\\s*" + attr + "\\s*:\\s*([^\\s:;]+)\\s*;")
	return (match && match[1]) || null;
};

// ジェネレータを格納するマップ
BlenderConditionPanel._genarators = {};

/**
 * 条件フィールドジェネレータを登録する
 *
 * @static
 * @param type {string} フィールド種類を表す文字列
 * @param generator {BlenderConditionPanel.CondFieldGenerator} ジェネレータインスタンス
 */
BlenderConditionPanel.registGenerator = function(type, generator) {
	BlenderConditionPanel._genarators[type] = generator;
};


(function(CondPanel) {
	"use strict";

	/**
	 * 条件フィールド生成クラス
	 * INPUT要素を1つもつ基本的な条件フィールドを生成する。
	 *
	 * @class CondFieldGenerator
	 * @namespace BlenderConditionPanel
	 * @module BlenderConditionPanel
	 * @constructor
	 * @param htmlText {String} 条件フィールドのHTML文字列表現
	 */
	function CondFieldGenerator(htmlText) {
		this._htmlText = htmlText;
	}

	CondPanel.CondFieldGenerator = CondFieldGenerator;

	/**
	 * 条件フィールドのHTML要素を生成する。
	 *
	 * @method createField
	 * @param condPanel {BlenderConditionPanel} 条件パネル本体
	 * @param modifyChecker {BlenderModifyChecker} 条件変更監視
	 * @param entry {Object} 条件パネル設定のオブジェクト
	 * @param msgData {Object} メッセージデータ
	 * @return {JQuery} HTML要素を格納したJQueryインスタンス
	 */
	CondFieldGenerator.prototype.createField = function(condPanel, modifyChecker, entry, msgData) {
		return this._createInputElement(condPanel, modifyChecker, entry, null, this._htmlText);
	};

	/**
	 * 条件フィールドの入力項目のHTML要素を生成する。
	 *
	 * @method _createInputElement
	 * @protected
	 * @param condPanel {BlenderConditionPanel} 条件パネル本体
	 * @param modifyChecker {BlenderModifyChecker} 条件変更監視
	 * @param entry {Object} 条件パネル設定のオブジェクト
	 * @param nameOpt {string} 名前オプション
	 * @param htmlText {string} 入力項目HTMLの文字列表現
	 * @return {JQuery} HTML要素を格納したJQueryインスタンス
	 */
	CondFieldGenerator.prototype._createInputElement = function(condPanel, modifyChecker, entry, nameOpt, htmlText) {
		var $field = $(htmlText);

		condPanel._setupField($field, entry, nameOpt);

		$field.change(function(e) {
			condPanel._change(e.target.name);
		});
		modifyChecker.addTarget($field);

		return $field;
	};

	/**
	 * 条件フィールドの追加のセットアップ処理の要否
	 *
	 * @private
	 * @propety {string} needSetup
	 */
	CondFieldGenerator.prototype.needSetup = false;

	/**
	 * 条件フィールドのセットアップの前処理を行う
	 *
	 * @method beforeSetup
	 * @param condPanel {BlenderConditionPanel} 条件パネル本体
	 * @param entry {Object} 条件パネル設定の本体
	 * @return {boolean} falseならば設定処理をスキップする
	 */
	CondFieldGenerator.prototype.beforeSetup = function(condPanel, entry) {
		return this.needSetup;
	};

	/**
	 * 条件フィールドのセットアップを行う
	 *
	 * @method setup
	 * @param condPanel {BlenderConditionPanel} 条件パネル本体
	 * @param modifyChecker {BlenderModifyChecker} 条件変更監視
	 * @param entry {Object} 条件パネル設定の本体
	 * @pram msgData {Object} メッセージデータ
	 */
	CondFieldGenerator.prototype.setup = function(condPanel, modifyChecker, entry, msgData) {
		// 処理なし
	};

	// ジェネレータを登録
	CondPanel.registGenerator("text", new CondFieldGenerator('<input type="text"/>'));
	CondPanel.registGenerator("checkbox", new CondFieldGenerator('<input type="checkbox"/>'));

}(BlenderConditionPanel));


(function(CondPanel, CondFieldGenerator) {
	"use strict";

	/**
	 * 選択コンボボックス条件フィールドジェネレータ
	 *
	 * @class SelecCondFieldGenerator
	 * @extends BlenderConditionPanel.CondFieldGenerator
	 * @module BlenderConditionPanel
	 * @constructor
	 */
	function SelectCondFieldGenerator() {}

	SelectCondFieldGenerator.inherit(CondFieldGenerator);

	/**
	 * 選択コンボボックスのHTML要素を生成する。
	 *
	 * @method createField
	 * @param condPanel {BlenderConditionPanel} 条件パネル本体
	 * @param modifyChecker {BlenderModifyChecker} 条件変更監視
	 * @param entry {Object} 条件パネル設定
	 * @return {JQuery} HTML要素を格納したJQueryインスタンス
	 */
	SelectCondFieldGenerator.prototype.createField = function(condPanel, modifyChecker, entry) {
		var $field = this._createInputElement(condPanel, modifyChecker, entry, null, "<select/>");
		var optionHtml = (entry.items || []).map(function(item) {
			return '<option value="' + item[0] + '">' + item[1] + "</option>";
		});
		$field.append(optionHtml);

		return $field;
	};


	/**
	 * 空白の条件フィールドジェネレータ
	 *
	 * @class SpanFieldGenerator
	 * @extends BlenderConditionPanel.CondFieldGenerator
	 * @module BlenderConditionPanel
	 * @constructor
	 */
	function SpanFieldGenerator() {}

	SpanFieldGenerator.inherit(CondFieldGenerator);

	/**
	 * 空白ののHTML要素を生成する。
	 *
	 * @method createField
	 * @param condPanel {BlenderConditionPanel} 条件パネル本体
	 * @param modifyChecker {BlenderModifyChecker} 条件変更監視
	 * @param entry {Object} 条件パネル設定
	 * @param msgData {Object} メッセージデータ
	 * @return {JQuery} HTML要素を格納したJQueryインスタンス
	 */
	SpanFieldGenerator.prototype.createField = function(condPanel, modifyChecker, entry, msgData) {
		var $field = $("<span />");
		condPanel._setupField($field, entry);
		return $field;
	};


	/**
	 * フィールドセットの条件フィールドジェネレータ
	 *
	 * @class FieldSetGenerator
	 * @extends SpanFieldGenerator
	 * @module BlenderConditionPanel
	 * @constructor
	 */
	function FieldSetGenerator() {}

	FieldSetGenerator.inherit(SpanFieldGenerator);

	/**
	 * フィールドセットのHTML要素を生成する。
	 *
	 * @method createField
	 * @param condPanel {BlenderConditionPanel} 条件パネル本体
	 * @param modifyChecker {BlenderModifyChecker} 条件変更監視
	 * @param entry {Object} 条件パネル設定
	 * @param msgData {Object} メッセージデータ
	 * @return {JQuery} HTML要素を格納したJQueryインスタンス
	 */
	FieldSetGenerator.prototype.createField = function(condPanel, modifyChecker, entry, msgData) {
		var $field = SpanFieldGenerator.prototype.createField.apply(this, arguments);
		$field.attr("id", entry.name).addClass("cond-panel-field-set");

		return $field;
	};

	/**
	 * フィールドセットのセットアップの前処理を行う
	 *
	 * @method beforeSetup
	 * @param condPanel {BlenderConditionPanel} 条件パネル本体
	 * @param entry {Object} 条件パネル設定の本体
	 * @return {boolean} falseならば設定処理をスキップする
	 */
	FieldSetGenerator.prototype.beforeSetup = function(condPanel, entry) {
		var showErr = console && console.error;
		var ret = (typeof BlenderInputFieldSet === "function");

		if (!ret && showErr) {
			showErr("blenderinputfieldset.js が include されていません。");
		}
		return ret;
	};

	/**
	 * フィールドセットのセットアップを行う
	 *
	 * @method setup
	 * @param condPanel {BlenderConditionPanel} 条件パネル本体
	 * @param modifyChecker {BlenderModifyChecker} 条件変更監視
	 * @param entry {Object} 条件パネル設定の本体
	 * @pram msgData {Object} メッセージデータ
	 */
	FieldSetGenerator.prototype.setup = function(condPanel, modifyChecker, entry, msgData) {
		var id = entry.name;
		var fldSet = new BlenderInputFieldSet(id);

		if (CondPanel.containsAttr(entry, CondPanel.COND_ATTR_BL_DISABLEDCLEARBTN)) {
			fldSet.disableClearBtn();
		}
		fldSet.init();

		fldSet.change(function(e){
			condPanel._change(e.src.tagId);
		});
		modifyChecker.addTarget(fldSet);

		window[id] = fldSet;
	};


	/**
	 * プレースホルダージェネレータ
	 *
	 * @class PlaceHolderGenerator
	 * @extends BlenderConditionPanel.CondFieldGenerator
	 * @module BlenderConditionPanel
	 * @constructor
	 */
	function PlaceHolderGenerator() {}

	PlaceHolderGenerator.inherit(CondFieldGenerator);

	/**
	 * プレースホルダーのHTML要素を生成する。
	 *
	 * @method createField
	 * @param condPanel {BlenderConditionPanel} 条件パネル本体
	 * @param modifyChecker {BlenderModifyChecker} 条件変更監視
	 * @param entry {Object} 条件パネル設定
	 * @param msgData {Object} メッセージデータ
	 * @return {JQuery} HTML要素を格納したJQueryインスタンス
	 */
	PlaceHolderGenerator.prototype.createField = function(condPanel, modifyChecker, entry, msgData) {
		// 別途画面内のJSP/HTML上に定義されている項目を移動
		// （data-placeholder-id が entry.name に一致する項目を探す）
		var $field = $("span[data-placeholder-id='" + entry.name + "']")
			.removeAttr("data-placeholder-id")
			.addClass("cond-type-placeholder");
		// JSP/HTML上の定義内容にホワイトスペース（空白、タブ、改行）が含まれていたら除去
		// （ホワイトスペース分の隙間が空かないようにする）
		$field.contents().filter(function() {
			return (this.nodeType == 3 && !/\S/.test(this.nodeValue));
		}).remove();

		condPanel._setupField($field, entry);
		//項目の初期化、modifyCheckerは画面で設定

		return $field;
	};


	/**
	 * 時間期間ジェネレータ
	 *
	 * @class TimeSpanGenerator
	 * @extends BlenderConditionPanel.CondFieldGenerator
	 * @module BlenderConditionPanel
	 * @constructor
	 */
	function TimeSpanGenerator() {}

	TimeSpanGenerator.inherit(CondFieldGenerator);

	/**
	 * BLEnDer TimeInputコンポーネントが必要かどうかを判定する。
	 *
	 * @method _isUseTimeInput
	 * @private
	 * @param entry {Object} 条件パネル設定
	 * @return {boolean} 範囲入力ならばtrue、そうでないならばfalse
	 */
	TimeSpanGenerator.prototype._isUseTimeInput = function(entry) {
		return CondPanel.containsAttr(entry, CondPanel.COND_ATTR_BL_SHOWTIME2);
	};

	/**
	 * 時間期間のHTML要素を生成する。
	 *
	 * @method createField
	 * @param condPanel {BlenderConditionPanel} 条件パネル本体
	 * @param modifyChecker {BlenderModifyChecker} 条件変更監視
	 * @param entry {Object} 条件パネル設定
	 * @param msgData {Object} メッセージデータ
	 * @return {JQuery} HTML要素を格納したJQueryインスタンス
	 */
	TimeSpanGenerator.prototype.createField = function(condPanel, modifyChecker, entry, msgData) {
		var $field = $("<span/>");
		var between = "<span class='cond-param-between'>" + msgData.symbolBetween + "</span>";
		var $start, $end;

		if (this._isUseTimeInput(entry)) {
			$start = $("<span/>").attr("id", entry.name + "S");
			$end = $("<span/>").attr("id", entry.name + "E");
		} else {
			var htmlText = "<input type='text' title='" + msgData.labelDatetime + "'/>";

			$start = this._createInputElement(condPanel, modifyChecker, entry, "S", htmlText);
			$end = this._createInputElement(condPanel, modifyChecker, entry, "E", htmlText);

			modifyChecker.addTarget($start);
			modifyChecker.addTarget($end);
		}
		$field.append($start, between, $end);

		return $field;
	};

	/**
	 * 時間入力のセットアップの前処理を行う
	 *
	 * @method beforeSetup
	 * @param condPanel {BlenderConditionPanel} 条件パネル本体
	 * @param entry {Object} 条件パネル設定の本体
	 * @return {boolean} falseならば設定処理をスキップする
	 */
	TimeSpanGenerator.prototype.beforeSetup = function(condPanel, entry) {
		if (!this._isUseTimeInput(entry)) {
			return false;
		}
		var showErr = console && console.error;
		var ret = (typeof BlenderTimeInput === "function");

		if (!ret && showErr) {
			showErr("blendertimeinput.js が include されていません。");
		}
		return ret;
	};

	/**
	 * 時間入力のセットアップを行う
	 *
	 * @method setup
	 * @param condPanel {BlenderConditionPanel} 条件パネル本体
	 * @param modifyChecker {BlenderModifyChecker} 条件変更監視
	 * @param entry {Object} 条件パネル設定の本体
	 * @pram msgData {Object} メッセージデータ
	 */
	TimeSpanGenerator.prototype.setup = function(condPanel, modifyChecker, entry, msgData) {
		var isDisabled = CondPanel.containsAttr(entry, "disabled");
		var isReadOnly = CondPanel.containsAttr(entry, "readonly");
		var name = entry.name;
		var timestep = parseInt(CondPanel.getAttrVal(entry, CondPanel.COND_ATTR_BL_TIMESTEP), 10) || 1;

		var onConditionChanged = function(e) {
			condPanel._change(e.src.tagId);
		};
		var onTimeChanged = function(e) {
			if (BlenderCalendarSettings.KEEP_INVERSE_RANGE) {
				return;
			}
			if (e.src === timeInputs[1]) {
				if (timeInputs[0].val() > e.value) {
					timeInputs[0].val(e.value);
				}
			} else if (e.src === timeInputs[0]) {
				if (e.value > timeInputs[1].val()) {
					timeInputs[1].val(e.value);
				}
			}
		};

		var timeInputs = [name + "S", name + "E"].map(function(id) {
			var timeInput = new BlenderTimeInput(id);

			timeInput.setOptions({
				steps: [1, timestep],
				editableText: !isReadOnly
			});
			timeInput.init();
			timeInput.setDisabled(isDisabled);

			timeInput.change(onConditionChanged);
			timeInput.change(onTimeChanged);

			modifyChecker.addTarget(timeInput);
			window[id] = timeInput;

			return timeInput;
		});
	};

	// ジェネレータを登録
	CondPanel.registGenerator("select", new SelectCondFieldGenerator);
	CondPanel.registGenerator("free", new SpanFieldGenerator);
	CondPanel.registGenerator("fldSet", new FieldSetGenerator);
	CondPanel.registGenerator("placeholder", new PlaceHolderGenerator);
	CondPanel.registGenerator("timespan", new TimeSpanGenerator);

}(BlenderConditionPanel, BlenderConditionPanel.CondFieldGenerator));


(function(CondPanel, CondFieldGenerator) {
	"use strict";

	/**
	 * カレンダージェネレータベース
	 *
	 * @class AbstCalCondFieldGenerator
	 * @extends BlenderConditionPanel.CondFieldGenerator
	 * @module BlenderConditionPanel
	 * @constructor
	 */
	function AbstCalCondFieldGenerator() {};

	AbstCalCondFieldGenerator.inherit(CondFieldGenerator);

	/**
	 * カレンダーの入力要素を作成する。
	 *
	 * @method _createCalInputElement
	 * @protected
	 * @param entry {Object} 条件パネル設定
	 * @param nameOp {String} 名前オプション(S: 開始/E: 終了)
	 * @return {Array} テキスト入力とカレンダーアイコン
	 */
	AbstCalCondFieldGenerator.prototype._createCalInputElement = function(entry, nameOp) {
		var ret = [];
		var id = entry.name + (nameOp || "");

		// 文字入力とカレンダーアイコン
		var $text = $("<input type='text' class='" + CondPanel.DT_CLASS + "'/>");
		var $calIcon = $("<img class='cal_icon' src='" + CondPanel.imagePath + CondPanel.ICON_CALENDAR + "'>");

		$text.attr({id: id, name: id});
		$calIcon.attr("id", id + "Cal");

		ret.push($text, $calIcon);

		return ret;
	};

	/**
	 * カレンダー入力がスピナー入力であるかを判定する
	 *
	 * @method _isTimeSpinner
	 * @protected
	 * @param entry {Object} 条件パネル設定
	 * @return {boolean} スピナー入力ならばtrue、そうでないならばfalse
	 */
	AbstCalCondFieldGenerator.prototype._isTimeSpinner = function(entry) {
		return CondPanel.containsAttr(entry, CondPanel.COND_ATTR_BL_TIMESPINNER);
	};

	/**
	 * カレンダースピナーボタンを生成する。
	 *
	 * @method _createArrowBtn
	 * @protected
	 * @param entry {Object} 条件パネル設定
	 * @param direction {boolean} 方向(左: false, 右: true)
	 * @return ボタン要素を格納したJQuery要素
	 */
	AbstCalCondFieldGenerator.prototype._createArrowBtn = function(entry, direction) {
		var self = this,
			name = entry.name,
			btnHoldCount = 0; // 長押しした時間

		return $("<button/>")
				.attr({
					id: name + "Arrow" + (direction ? "R" : "L"),
					type: "button"
				})
				.addClass("cal_icon arrow_" + (direction ? "r" : "l"))
				.val(direction ? "next" : "prev")
				.on({
					click: function(e) {
						var cal = window[e.data.target];
						var val = e.target.value;

						if (!btnHoldCount && cal && cal[val]) {
							self._spinnerClick(cal, val, e);
						}
					},

					mousedown: function(dEv) {
						var cal = window[dEv.data.target],
							val = dEv.target.value;

						if (!cal || !cal[val]) {
							return false;
						}
						var $document = $(document),
							namespace = "." + dEv.target.id,
							timeoutId = false;

						btnHoldCount = 0; // 長押し時間リセット

						// 終了処理
						function stop(uEv) {
							if (btnHoldCount && uEv) {
								self._spinnerHold(cal, val, uEv);
							}
							timeoutId && window.clearTimeout(timeoutId);
							$document.off(namespace);
						}

						stop(); // 多重イベント防止のため

						// 長押し中ループ
						function loop() {
							self._spinnerHold(cal, val, dEv);

							timeoutId = window.setTimeout(loop,
									Math.max(100, 300 - btnHoldCount * 20));
							btnHoldCount++;
						}

						$document.on("mouseup" + namespace, stop)
								.on("mouseleave" + namespace, stop);

						timeoutId = window.setTimeout(loop, 800);
					}
				}, { target: name });
	};

	/**
	 * スピナーボタンクリック時の処理
	 *
	 * @protected
	 * @method _spinnerClick
	 * @param calendar {BlenderCalendar} カレンダーインスタンス
	 * @param value {string} ボタンの値
	 * @param event {MouseEvent} マウスイベント
	 */
	AbstCalCondFieldGenerator.prototype._spinnerClick = function(calendar, value, event) {
		calendar[value]();
	};

	/**
	 * スピナーボタン長押し時に一定周期で実行する処理
	 *
	 * @protected
	 * @method _spinnerHold
	 * @param calendar {BlenderCalendar} カレンダーインスタンス
	 * @param value {string} ボタンの値
	 * @param event {Event} イベントオブジェクト
	 */
	AbstCalCondFieldGenerator.prototype._spinnerHold = function(calendar, value, event) {
		calendar[value]();
	};

	/**
	 * カレンダー入力ジェネレータ
	 *
	 * @class CalendarCondFieldGenerator
	 * @extends AbstCalCondFieldGenerator
	 * @module BlenderConditionPanel
	 * @constructor
	 */
	function CalendarCondFieldGenerator() {}

	CalendarCondFieldGenerator.inherit(AbstCalCondFieldGenerator);

	/**
	 * カレンダー入力が範囲入力であるかを判定する
	 *
	 * @method _isSpan
	 * @private
	 * @param entry {Object} 条件パネル設定
	 * @return {boolean} 範囲入力ならばtrue、そうでないならばfalse
	 */
	CalendarCondFieldGenerator.prototype._isSpan = function(entry) {
		return entry.type === "calendarspan"
			|| CondPanel.containsAttr(entry, CondPanel.COND_ATTR_BL_RANGE);
	};

	/**
	 * Blender Calendarコンポーネント内に時刻を表示するかどうかを判定する。
	 *
	 * @method _isShowTime
	 * @private
	 * @param entry {Object} 条件パネル設定
	 * @return {boolean} カレンダー無いの時刻表示を行うならば true そうでないならば false
	 */
	CalendarCondFieldGenerator.prototype._isShowTime = function(entry) {
		return CondPanel.containsAttr(entry, CondPanel.COND_ATTR_BL_SHOWTIME);
	};

	/**
	 * BLEnDer TimeInputコンポーネントが必要かどうかを判定する。
	 *
	 * @method _isUseTimeInput
	 * @private
	 * @param entry {Object} 条件パネル設定
	 * @return {boolean} 範囲入力ならばtrue、そうでないならばfalse
	 */
	CalendarCondFieldGenerator.prototype._isUseTimeInput = function(entry) {
		return !this._isShowTime(entry) && CondPanel.containsAttr(entry, CondPanel.COND_ATTR_BL_SHOWTIME2);
	};

	/**
	 * カレンダーののHTML要素を生成する。
	 *
	 * @method createField
	 * @param condPanel {BlenderConditionPanel} 条件パネル本体
	 * @param modifyChecker {BlenderModifyChecker} 条件変更監視
	 * @param entry {Object} 条件パネル設定
	 * @param msgData {Object} メッセージデータ
	 * @return {JQuery} HTML要素を格納したJQueryインスタンス
	 */
	CalendarCondFieldGenerator.prototype.createField = function(condPanel, modifyChecker, entry, msgData) {
		var isUseTimeInput = this._isUseTimeInput(entry);
		var $field = $("<span/>");

		if (this._isSpan(entry)) {
			// 期間指定

			// 開始
			$field.append(this._createCalInputElement(entry, "S"));
			if (isUseTimeInput) {
				$field.append(this._createTimeInputElement(entry, "S"));
			}

			// ～
			$field.append("<span class='cond-param-between'>" + msgData.symbolBetween + "</span>");

			// 終了
			$field.append(this._createCalInputElement(entry, "E"));
			if (isUseTimeInput) {
				$field.append(this._createTimeInputElement(entry, "E"));
			}
		} else {
			var isTimeSpinner = this._isTimeSpinner(entry);

			// [≪]ボタン
			if (isTimeSpinner) {
				$field.append(this._createArrowBtn(entry, false));
			}
			// 入力セット
			$field.append(this._createCalInputElement(entry));

			// [≫]ボタン
			if (isTimeSpinner) {
				$field.append(this._createArrowBtn(entry, true));
			}

			// 時刻入力
			if (isUseTimeInput) {
				$field.append(this._createTimeInputElement(entry));
			}
		}

		var suffixLabel = CondPanel.getAttrVal(entry, CondPanel.COND_ATTR_BL_SUFFIX);
		if (suffixLabel) {
			$field.append("<span>" + suffixLabel + "</span>");
		}

		condPanel._setupField($field, entry);

		return $field;
	};

	/**
	 * カレンダーの入力要素を作成する。
	 *
	 * @method _createCalInputElement
	 * @private
	 * @param entry {Object} 条件パネル設定
	 * @param nameOp {String} 名前オプション(S: 開始/E: 終了)
	 * @return {Array} テキスト入力とカレンダーアイコン
	 */
	CalendarCondFieldGenerator.prototype._createCalInputElement = function(entry, nameOp) {
		var ret = AbstCalCondFieldGenerator.prototype._createCalInputElement.apply(this, arguments);

		if (this._isShowTime(entry)) {
			ret[0].addClass(CondPanel.DT_CLASS_SHOWTIME);
		}
		return ret;
	};

	/**
	 * 時刻の入力要素を作成する。
	 *
	 * @method _createTimeInputElement
	 * @private
	 * @param entry {Object} 条件パネル設定
	 * @param nameOp {String} 名前オプション(S: 開始/E: 終了)
	 * @return {JQuery} 時刻入力要素を格納したJQueryインスタンス
	 */
	CalendarCondFieldGenerator.prototype._createTimeInputElement = function(entry, nameOp) {
		return $("<span/>").attr("id", entry.name + (nameOp || "") + "Time");
	};

	/**
	 * カレンダーのセットアップの前処理を行う
	 *
	 * @method beforeSetup
	 * @param condPanel {BlenderConditionPanel} 条件パネル本体
	 * @param entry {Object} 条件パネル設定の本体
	 * @return {boolean} falseならば設定処理をスキップする
	 */
	CalendarCondFieldGenerator.prototype.beforeSetup = function(condPanel, entry) {
		var showErr = console && console.error;
		var existsCal = (typeof BlenderCalendar === "function");

		if (!existsCal && showErr) {
			showErr("blendercalendar.js が include されていません。");
		}

		var existsTime = true;

		if (this._isUseTimeInput(entry)) {
			existsTime = (typeof BlenderTimeInput === "function");

			if (!existsTime && showErr) {
				showErr("blendertimeinput.js が include されていません。");
			}
		}
		return existsCal && existsTime;
	};

	/**
	 * カレンダーのセットアップを行う
	 *
	 * @method setup
	 * @param condPanel {BlenderConditionPanel} 条件パネル本体
	 * @param modifyChecker {BlenderModifyChecker} 条件変更監視
	 * @param entry {Object} 条件パネル設定の本体
	 * @pram msgData {Object} メッセージデータ
	 */
	CalendarCondFieldGenerator.prototype.setup = function(condPanel, modifyChecker, entry, msgData) {
		var isSpan = this._isSpan(entry); // 範囲選択フラグ
		var isDisabled = CondPanel.containsAttr(entry, "disabled");
		var isReadOnly = CondPanel.containsAttr(entry, "readonly");
		var isRequired = CondPanel.containsAttr(entry, CondPanel.COND_ATTR_BL_REQUIRED); // 必須フラグ

		var isShowTime = this._isShowTime(entry); // 時刻表示フラグ
		var timeInterval = isShowTime && parseInt(CondPanel.getAttrVal(entry, CondPanel.COND_ATTR_BL_SHOWTIME), 10);

		var name = entry.name;
		var ids = isSpan ? [name + "S", name + "E"] : [name];

		var onConditionChanged = function(e) {
			condPanel._change(e.src.tagId);
		};
		var registComponent = function(comp) {
			comp.change(onConditionChanged);
			modifyChecker.addTarget(comp);
			window[comp.tagId] = comp;
		};

		// カレンダー入力作成
		var cals = ids.map(function(id) {
			var cal = new BlenderCalendar(id);

			cal.attachIcon(id + "Cal");
			cal.setEditable(!isDisabled && !isReadOnly);
			cal.setRequired(isRequired);
			cal.init({ isEditable : true });

			isShowTime && cal.showTime(timeInterval);
			isRequired && cal.setDate(new Date);

			return cal;
		});

		cals.forEach(registComponent);

		// 時間入力の作成
		var timeInputs = this._isUseTimeInput(entry);

		if (timeInputs) {
			var timestep = parseInt(CondPanel.getAttrVal(entry, CondPanel.COND_ATTR_BL_TIMESTEP), 10) || 1;

			timeInputs = ids.map(function(id) {
				var timeId = id + "Time";
				var timeInput = new BlenderTimeInput(timeId);

				timeInput.setOptions({
					steps: [1, timestep],
					editableText: !isReadOnly
				});
				timeInput.init();
				timeInput.setDisabled(isDisabled);

				return timeInput;
			});

			timeInputs.forEach(registComponent);
		}

		if (isSpan) {
			cals[0].setAfterCalendar(cals[1]);
			cals[1].setBeforeCalendar(cals[0]);

			if (timeInputs) {
				// 期間の逆転防止
				var onValChanged = function(e) {
					if (BlenderCalendarSettings.KEEP_INVERSE_RANGE) {
						return;
					}
					var cVal1 = cals[0].val(),
						cVal2 = cals[1].val(),
						val;

					if (!cVal1 || !cVal2 || cVal1 < cVal2) {
						return;
					}
					if (e.src === timeInputs[1] || e.src === cals[1]) {
						val = timeInputs[1].val();
						if (timeInputs[0].val() > val) {
							timeInputs[0].val(val);
						}
					} else if (e.src === timeInputs[0] || e.src === cals[0]) {
						val = timeInputs[0].val();
						if (val > timeInputs[1].val()) {
							timeInputs[1].val(val);
						}
					}
				};

				[].concat(cals, timeInputs).forEach(function(item) {
					item.change(onValChanged);
				});
			}
		}
	};


	/**
	 * 月カレンダー入力ジェネレータ
	 *
	 * @class MonthCalendarCondFieldGenerator
	 * @extends AbstCalCondFieldGenerator
	 * @module BlenderConditionPanel
	 * @constructor
	 */
	function MonthCalendarCondFieldGenerator() {}

	MonthCalendarCondFieldGenerator.inherit(AbstCalCondFieldGenerator);

	/**
	 * 月カレンダーののHTML要素を生成する。
	 *
	 * @method createField
	 * @param condPanel {BlenderConditionPanel} 条件パネル本体
	 * @param modifyChecker {BlenderModifyChecker} 条件変更監視
	 * @param entry {Object} 条件パネル設定
	 * @param msgData {Object} メッセージデータ
	 * @return {JQuery} HTML要素を格納したJQueryインスタンス
	 */
	MonthCalendarCondFieldGenerator.prototype.createField = function(condPanel, modifyChecker, entry, msgData) {
		var isTimeSpinner = this._isTimeSpinner(entry);
		var $field = $("<span/>");

		if (isTimeSpinner) {
			$field.append(this._createArrowBtn(entry, false));
		}
		$field.append(this._createCalInputElement(entry));

		if (isTimeSpinner) {
			$field.append(this._createArrowBtn(entry, true));
		}
		condPanel._setupField($field, entry);

		return $field;
	};

	/**
	 * 月カレンダーのセットアップの前処理を行う
	 *
	 * @method beforeSetup
	 * @param condPanel {BlenderConditionPanel} 条件パネル本体
	 * @param entry {Object} 条件パネル設定の本体
	 * @return {boolean} falseならば設定処理をスキップする
	 */
	MonthCalendarCondFieldGenerator.prototype.beforeSetup = function(condPanel, entry) {
		var showErr = console && console.error;
		var ret = (typeof BlenderMonthCalendar === "function");

		if (!ret && showErr) {
			showErr("blendermonthcalendar.js が include されていません。");
		}
		return ret;
	};

	/**
	 * 月カレンダーのセットアップを行う
	 *
	 * @method setup
	 * @param condPanel {BlenderConditionPanel} 条件パネル本体
	 * @param modifyChecker {BlenderModifyChecker} 条件変更監視
	 * @param entry {Object} 条件パネル設定の本体
	 * @pram msgData {Object} メッセージデータ
	 */
	MonthCalendarCondFieldGenerator.prototype.setup = function(condPanel, modifyChecker, entry, msgData) {
		var id = entry.name;
		var isDisabled = CondPanel.containsAttr(entry, "disabled");
		var isReadOnly = CondPanel.containsAttr(entry, "readonly");
		var isRequired = CondPanel.containsAttr(entry, CondPanel.COND_ATTR_BL_REQUIRED);

		var cal = new BlenderMonthCalendar(id);

		cal.attachIcon(id + "Cal");
		cal.setEditable(!isDisabled && !isReadOnly);
		cal.setRequired(isRequired);
		isRequired && cal.setDate(new Date);

		cal.init({
			isYearEditable: true,
			isStartInApril: (entry.type === "mcalendarBY")
		});
		cal.change(function(e) {
			condPanel._change(e.src.tagId);
		});
		modifyChecker.addTarget(cal);
		window[id] = cal;
	};

	/**
	 * スピナーボタン長押し時に一定周期で実行する処理
	 *
	 * @protected
	 * @method _spinnerHold
	 * @param calendar {BlenderCalendar} カレンダーインスタンス
	 * @param value {string} ボタンの値
	 * @param event {Event} イベントオブジェクト
	 */
	MonthCalendarCondFieldGenerator.prototype._spinnerHold = function(calendar, value, event) {
		if (event.type === "mousedown") {
			calendar.setNotifyMode(BlenderMonthCalendar.NOTIFYMODE_SILENT); // 長押し中は値変更イベントを通知しない
		} else {
			calendar.setNotifyMode(BlenderMonthCalendar.NOTIFYMODE_USUALLY);
		}
		calendar[value]();
	};

	// ジェネレータを登録
	var calCondFieldGenerator = new CalendarCondFieldGenerator;
	var mCalCondFieldGenerator = new MonthCalendarCondFieldGenerator;

	CondPanel.registGenerator("calendar", calCondFieldGenerator);
	CondPanel.registGenerator("calendarspan", calCondFieldGenerator);
	CondPanel.registGenerator("mcalendar", mCalCondFieldGenerator);
	CondPanel.registGenerator("mcalendarBY", mCalCondFieldGenerator);

}(BlenderConditionPanel, BlenderConditionPanel.CondFieldGenerator));

/*
Copyright MITSUBISHI Elec.
*/
